import axios from 'axios';
import _get from 'lodash/get';

import { API_SERVER } from './index';

// Configure axios instances
axios.defaults.baseURL = `${API_SERVER}/api/v1`;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';

// Create instance
const axiosInstance = axios.create();

// Axios wrapper to handle error
const axiosWrapper = apiCall => apiCall.then(res => res.data).catch(err => Promise.reject(err));

// Define API calls for Diagnostics
let api = {
  // Diagnostic APIs
  auth:{
    login: (data) => axiosWrapper(axiosInstance.post('/auth/login', data)),
  },
  diagnostics: {
    getAll: () => axiosWrapper(axiosInstance.get('/diagnostics')),
    create: (data) => axiosWrapper(axiosInstance.post('/diagnostics', data)),
    getById: (id) => axiosWrapper(axiosInstance.get(`/diagnostics/${id}`)),
    update: (id, data) => axiosWrapper(axiosInstance.put(`/diagnostics/${id}`, data)),
    delete: (id) => axiosWrapper(axiosInstance.delete(`/diagnostics/${id}`)),
    dailyRunsTime: (id, data) => axiosWrapper(axiosInstance.post(`/diagnostics/update-time/${id}`, data)),

  },

  // Diagnostic Test Case APIs
  diagnosticTestCases: {
    getAll: () => axiosWrapper(axiosInstance.get('/diagnostic-test-cases')),
    create: (data) => axiosWrapper(axiosInstance.post('/diagnostic-test-cases', data)),
    getById: (id) => axiosWrapper(axiosInstance.get(`/diagnostic-test-cases/${id}`)),
    update: (id, data) => axiosWrapper(axiosInstance.put(`/diagnostic-test-cases/${id}`, data)),
    delete: (id) => axiosWrapper(axiosInstance.delete(`/diagnostic-test-cases/${id}`)),

  },

  // Diagnostic History APIs
  diagnosticHistories: {
    getAll: () => axiosWrapper(axiosInstance.get('/diagnostic-histories')),
    create: (data) => axiosWrapper(axiosInstance.post('/diagnostic-histories', data)),
    getById: (id) => axiosWrapper(axiosInstance.get(`/diagnostic-histories/${id}`)),
    update: (id, data) => axiosWrapper(axiosInstance.put(`/diagnostic-histories/${id}`, data)),
    delete: (id) => axiosWrapper(axiosInstance.delete(`/diagnostic-histories/${id}`)),
  },

  // Diagnostic History Report APIs
  diagnosticHistoryReports: {
    getAll: () => axiosWrapper(axiosInstance.get('/diagnostic-history-reports')),
    create: (data) => axiosWrapper(axiosInstance.post('/diagnostic-history-reports', data)),
    getById: (id) => axiosWrapper(axiosInstance.get(`/diagnostic-history-reports/${id}`)),
    update: (id, data) => axiosWrapper(axiosInstance.put(`/diagnostic-history-reports/${id}`, data)),
    delete: (id) => axiosWrapper(axiosInstance.delete(`/diagnostic-history-reports/${id}`)),
    runTestCase: (id) => axiosWrapper(axiosInstance.post(`/diagnostic-history-reports/run-test-case/${id}`)),
  },
};

export default api;
